import { useContext } from 'react';
import { Link } from 'react-router';

import { ApplicationContext } from '../../../../shared/source/context/context';

import type { FunctionComponent } from 'react';

export const CompanyLogo: FunctionComponent = () => {
    const { applicationState } = useContext(ApplicationContext);
    const companyLogoUrl = applicationState.customization.get('uiConfiguration').get('assets').get('companyLogoUrl');

    if (companyLogoUrl.isJust) {
        return (
            <Link to="/">
                <img alt="Company logo" src={companyLogoUrl.value.href} width={100} />
            </Link>
        );
    }

    return null;
};
